module.exports = __webpack_public_path__ + "img/b21b6e8.png";